import { formatSize } from './format'

export const MAX_FILE_SIZE = 50 * 1024 * 1024 // 50 MB
export const ALLOWED_CONTENT_TYPES = [
	'application/pdf',
	'image/png',
	'image/jpeg',
	'image/svg+xml',
	'image/webp',
	'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
	'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
	'application/vnd.openxmlformats-officedocument.presentationml.presentation',
	'text/csv',
	'text/plain',
]
export const ALLOWED_EXTENSIONS = 'PDF, PNG, JPG, SVG, WebP, DOCX, XLSX, PPTX, CSV, TXT'

/**
 * Validate a file before upload. Returns error message or null if valid.
 */
export function validateFile(file: File): string | null {
	if (file.size > MAX_FILE_SIZE) {
		return `File size (${formatSize(file.size)}) exceeds maximum of ${formatSize(MAX_FILE_SIZE)}`
	}
	if (!ALLOWED_CONTENT_TYPES.includes(file.type)) {
		return `File type "${file.type || 'unknown'}" is not allowed. Allowed: ${ALLOWED_EXTENSIONS}`
	}
	return null
}
